module.exports = __webpack_public_path__ + "img/occasions.8d13f8c8.svg";